import React, { useState } from "react";
import styles from "../../../Styles/Home.module.css";

import { useWallet } from "@manahippo/aptos-wallet-adapter";

import aptosLogo from "../../../assets/aptosLogo.png";
import ConnectWalletModal from "./ConnectWalletModal";
import styled from "styled-components";
import {
  ContainedButton,
  MintingText,
} from "../../../components/NavBar/NavbarComponents";
import { Colors } from "../../Colors";
import { Row } from "../../../Styles";

const ConnectWalletButton = (props) => {
  const { connectButton, className, style, disabled } = props;

  const wallet = useWallet();
  const [showModal, setShowModal] = useState(false);

  function handleButtonClick() {
    if (connectButton) {
      setShowModal(true);
      return;
    }
    wallet.disconnect();
  }

  const button = (
    <ContainedButton
      backgroundColor={Colors.TOHOH}
      color={Colors.BLACK}
      disabled={disabled}
      className={`${styles.connectWalletBtn} ${className} ${
        disabled ? "disabled" : ""
      }`}
      onClick={handleButtonClick}
      style={{ ...style, width: "130px" }}
    >
      <MintingText>
        <Row align="center">
          <img src={aptosLogo} />
          {connectButton ? "Connect" : "Disconnect"}
        </Row>
      </MintingText>
    </ContainedButton>
  );

  return (
    <>
      {connectButton ? (
        button
      ) : wallet.account?.address?.toString() !== undefined ? (
        <span className="mx-auto w-100">{button}</span>
      ) : null}
      <ConnectWalletModal
        show={showModal}
        onConnect={() => setShowModal(false)}
      />
    </>
  );
};

export default ConnectWalletButton;

const ConnectButton = styled.button``;
